import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";


const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return { day, month, year };
};


const parseNews = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const span = div.querySelector(".news-time");
  const time = span?.textContent || "";
  span?.remove();

  const message = div.textContent?.trim() || "";
  return { time, message };
};

const AnnouncementBox = ({ siteNews = [], onClose }) => {
  const perPage = 3;
  const [page, setPage] = useState(0);

  if (!siteNews || siteNews.length === 0) return null;

  const parsedNews = siteNews.map((item) => {
    const { time, message } = parseNews(item);
    const timeParts = time?.split(" - ")[1]; 
    const date = timeParts || new Date();
    const { day, month, year } = formatDate(date);
    return { day, month, year, message };
  });

  const totalPages = Math.ceil(parsedNews.length / perPage);
  const currentItems = parsedNews.slice(
    page * perPage,
    page * perPage + perPage
  );

  return (
    <div className="w-full h-[80vh] max-w-md mx-auto bg-white shadow-md rounded-md overflow-hidden text-black font-sans z-[999999]">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-2"
         style={{
            color: "#ffb200",
            backgroundImage: "linear-gradient(180deg, #474747 0%, #070707 100%)",
          
          }}
      >
        <h2 className="text-yellow-400 font-bold text-sm">Announcement</h2>
     
      </div>

      {/* Body */}
      <div className="px-4 py-3 space-y-4 pb-0 pt-6 text-sm max-h-[70vh] overflow-auto relative">
        {currentItems.map((item, index) => (
          <div key={index} className="space-y-1">
            {/* Date */}
            <div className="flex items-end gap-1 text-center announcement-day text-[#4e4e4e]">
              <div className="text-2xl">{item.day}</div>
              <div className="flex flex-col leading-tight">
                <span className="text-[12px]">{item.month}</span>
                <span className="text-[12px]">{item.year}</span>
              </div>
            </div>

            {/* Message */}
            <p className="whitespace-pre-line text-[13px] pb-4 pt-1">{item.message}</p>
            <hr className="border-t border-gray-300" />
          </div>
        ))}

        <div className="sticky bottom-0 bg-white border-t border-gray-300 py-2 px-4">
          <div className="flex justify-between items-center gap-3">
            <button
              onClick={() => setPage((p) => Math.max(p - 1, 0))}
              disabled={page === 0}
              className="px-3 py-1 bg-gray-200 text-[13px] rounded disabled:opacity-50"
            >
              Prev
            </button>
            <span className="text-[13px] font-semibold">
              Page {page + 1} of {totalPages}
            </span>
            <button
              onClick={() => setPage((p) => Math.min(p + 1, totalPages - 1))}
              disabled={page >= totalPages - 1}
              className="px-3 py-1 bg-gray-200 text-[13px] rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBox;
